/**
 * 顶通广告
 */
import React, { useEffect } from "react"
import { isBaidu, isIOS, isWeChat } from "../utils"
import "./index.less"

export function AdvertiseTop() {
  useEffect(() => {
    let UA = navigator.userAgent.toLowerCase()
    let fixed = "fixed_top"
    if (isWeChat()) {
      fixed = "fixed_bottom"
    }
    // 若为搜狗/QQ浏览器，则不展示顶通广告
    if (UA.indexOf("qqbrowser") < 0 && UA.indexOf("sogou") < 0) {
      // let this_page_ad2 = new window.emwapas("index", "index_indexdt") //pageid 页面代码
      let this_page_ad2 = new window.emwapas("Stock_quotes_page","Stock_quotes_page_DTT") //pageid 页面代码
      this_page_ad2.load(
        function () {
          // 顶通广告
          let ad_header = this_page_ad2.getAD({
             adpositioncode: "Stock_quotes_page_DTT",
            // adpositioncode: "index_indexdt",
            element_id: "ad-header",
            type: "roll",
            fixed: fixed,
            fixed_top: 0, //自定义fixed top 非必填
            bodypadding: true, //不要自动压下body 默认true 非必填
            show_type: 3, // 1: 不可关闭  2: 当天不显示  3: 可以关闭
            pagination: true, // 默认不显示，轮播广告必传
            style: "z-index:99",
            container_class: "comm-nav", // 必传
          })

          let res = ad_header.show()
          if (res.isShow) {
            res.getADHeight().then(
              function (val: any) {
                // val为广告图片高度
                // if (isBaidu()) {
                window.onscroll = () => {
                  let height = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
                  // 兼容ios下拉
                  // let startX = 0,
                  //   startY = 0,
                  //   endX = 0,
                  //   endY = 0,
                  //   moveX = 0,
                  //   moveY = 0
                  // let body: any = document.querySelector("body")
                  // body.addEventListener("touchstart", (e: any) => {
                  //   startX = e.touches?.[0].screenX
                  //   startY = e.touches?.[0].screenY
                  // })
                  // body.addEventListener("touchend", (e: any) => {
                  //   endX = e.changedTouches?.[0]?.screenX
                  //   endY = e.changedTouches?.[0]?.screenY
                  //   moveX = startX - endX
                  //   moveY = startY - endY
                  // })
                  // if (Math.abs(moveX) <= Math.abs(moveY)) {
                  //   // 上滑
                  //   if (moveY > 0) {
                  //     $("#swiper-ad").css("position", "relative")
                  //     $("body").css("padding-top", "0")
                  //   } else {
                  //     // 下拉
                  //     $("#swiper-ad").css("position", "fixed")
                  //     $("body").css("padding-top", "60px")
                  //   }
                  // }
                  if (fixed == "fixed_top") {
                    if (height >= val) {
                      $("#swiper-ad").css("position", "relative")
                      $(".comm-nav").css("top", 0)
                      $("body").css("padding-top", "0")
                    } else {
                      let ad_container = $("#swiper-ad")
                      if (ad_container?.[0]) {
                        ad_container.css("position", "fixed")
                        $(".comm-nav").css("top", val + "px")
                        $("body").css("padding-top", val + "px")
                      }
                    }
                  } else {
                    $("body").css("padding-bottom", "10px")
                  }
                }
                // } else {
                //   $(".comm-nav").css("top", val + "px")
                // }

                //  TODO
                //  let adtimes = 0
                //  let cd = setInterval(function () {
                //    adtimes++
                //    if (adtimes > 100) {
                //      clearInterval(cd)
                //    }
                //    if (!$("#swiper-ad").is(":visible")) {
                //     //  window.onscroll = function () {}
                //      $(".comm-nav").css("top", 0)
                //     //  $("#swiper-ad").css("display", "none")
                //     //  $("#ad-header").remove()
                //      $("body").css("padding-top", "0")
                //     //  alert($("body")[0].style.paddingTop)
                //     //  alert($(".comm-nav")[0].style.top)
                //      clearInterval(cd)
                //    }
                //  }, 100)
              },
              function (error: any) {}
            )
          }
        },
        undefined,
        {
          shichang: window.quotedata.market || "",
        }
      )
    }
    return () => {
      window.onscroll = null
    }
  }, [])

  return <div id="ad-header" className="ad-header-top"></div>
}
